<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';
import { useChatSoundNotifications } from '@/shared/composables/useChatSoundNotifications';
import { useLogoutSubscription } from '@/shared/composables/useLogoutSubscription';
import { usePushDeviceOwner } from '@/shared/composables/usePushDeviceOwner';

import EmptyLayout from '@/shared/layouts/EmptyLayout.vue';
import MainLayout from '@/shared/layouts/MainLayout.vue';

import { uk } from '@nuxt/ui/locale';

useLogoutSubscription();
usePushDeviceOwner();
useChatSoundNotifications();

// Lazy: the lightbox lives in `@ugi/core/editor`, which the first paint does
// not need.
const AppImageLightbox = defineAsyncComponent(() => import('@/shared/components/AppImageLightbox.vue'));

const route = useRoute();
const layoutName = computed((): 'main' | 'empty' => (route.meta.layout === 'main' ? 'main' : 'empty'));
</script>

<template>
  <UApp
    :locale="uk"
    :toaster="{ progress: false }"
  >
    <UDashboardGroup
      unit="rem"
      storage="local"
    >
      <MainLayout v-if="layoutName === 'main'" />
      <EmptyLayout v-else />
    </UDashboardGroup>

    <AppImageLightbox />
  </UApp>
</template>
